import React from 'react';
import { Link } from 'react-router-dom';
import { get } from 'lodash';
import CommonBadges from '../../Shared/Badges';
import { Row, Col } from 'react-bootstrap'

const getCampaignColumn = () => {
  return [
    {
      dataField: 'campaign_id',
      text: 'Campaign Id',
      sort: true,
      style: { width: '500px', overflow: 'hidden', textOverflow: 'ellipsis' }
    },
    {
      dataField: 'name',
      text: 'Campaign',
      sort: true,
      width: '200px',
    },
    {
      dataField: 'campaign_status',
      text: 'Status',
      sort: true,
      width: '200px',
      formatter: (cell, row) => {
        let status = get(row, 'campaign_status');
        let variant = status === 'completed' ? 'success' : status === 'ongoing' ? 'info' : 'danger';
        return <CommonBadges color={variant} value={status} />;
      },
    },
    {
      dataField: 'view_details',
      text: 'Booking Plan',
      sort: true,
      width: '200px',
      formatter: (cell, row) => {
        const { campaign_id } = row;
        return (
          <div>
            <Link
              style={{ color: '#e8578d' }}
              to={`/#/${campaign_id}/releasePlan`}
              state={{
                campaign_id
              }}
              target={'_blank'}
            >
              {'View Details'}
            </Link>
          </div>
        );
      },
    },
    {
      dataField: 'supplier_count',
      text: 'Entity Count',
      sort: true,
      width: '200px',
    },
    {
      dataField: 'city',
      text: 'City',
      sort: true,
      width: '200px',
    },
    {
      dataField: 'flat_count_details',
      text: 'Flat Count',
      sort: false,
      width: '500px',
      headerFormatter: (column) => (<><Row className="text-center"><div className="col">
        <p>Flat Count</p></div> </Row><Row > <Col>Filled </Col> <Col >Not Filled </Col> </Row> </>),
      formatter: (cell, row, rowIndex, extraData) => {
        const {
          campaign_id,
          name,
          flat_count_details_filled_suppliers,
          flat_count_details_filled,
          flat_count_details_filled_percentage,
          flat_count_details_not_filled_suppliers,
          flat_count_details_not_filled,
          flat_count_details_not_filled_percentage,
        } = row;
        return (<Row >
          <Col>
            {flat_count_details_filled_suppliers &&
              flat_count_details_filled_suppliers.length > 0 ? (
              <Link
                style={{ color: '#e8578d' }}
                to={`${campaign_id}/suppliers`}
                state={{
                  suppliers: flat_count_details_filled_suppliers,
                  campaign_id,
                  name,
                  type: 'Flat Count Filled',
                }}
              >
                {' '}
                {flat_count_details_filled}
                <p style={{ color: 'green' }}>
                  ({flat_count_details_filled_percentage}
                  %)
                </p>
              </Link>
            ) : (
              flat_count_details_filled
            )}
          </Col> <Col >
            {flat_count_details_not_filled && flat_count_details_not_filled_suppliers.length > 0 ? (
              <Link
                style={{ color: '#e8578d' }}
                to={`${campaign_id}/suppliers`}
                state={{
                  suppliers: flat_count_details_not_filled_suppliers,
                  campaign_id,
                  name,
                  type: 'Flat Count Not Filled',
                }}
              >
                {' '}
                {flat_count_details_not_filled}
                <p style={{ color: 'green' }}>
                  ({flat_count_details_not_filled_percentage}
                  %)
                </p>
              </Link>
            ) : (
              flat_count_details_not_filled
            )}
          </Col> </Row>)
      }
    },
    {
      dataField: 'contact_name',
      text: 'Contact Name',
      sort: false,
      width: '500px',
      headerFormatter: (column) => (<><Row className="text-center"><div className="col">
        <p>Contact Name</p>
      </div> </Row><Row > <Col>Filled(Unique)</Col><Col >Total Filled</Col><Col >Not Filled</Col></Row> </>),
      formatter: (cell, row, rowIndex, extraData) => {
        const {
          name,
          campaign_id,
          contact_name_filled,
          contact_name_filled_suppliers,
          contact_name_filled_percentage,
          contact_name_filled_total,
          contact_name_not_filled,
          contact_name_not_filled_suppliers,
          contact_name_not_filled_percentage,
        } = row;
        return (<Row >
          <Col>
            {contact_name_filled_suppliers.length > 0 ? (
              <Link
                style={{ color: '#e8578d' }}
                to={`${campaign_id}/suppliers`}
                state={{
                  suppliers: contact_name_filled_suppliers,
                  campaign_id,
                  name,
                  type: 'Contact Name Filled',
                  is_contact_name: true,
                }}
              >
                {' '}
                {contact_name_filled}
                <p style={{ color: 'green' }}>
                  ({contact_name_filled_percentage}
                  %)
                </p>
              </Link>
            ) : (
              contact_name_filled
            )}
          </Col>
          <Col >
            {contact_name_filled_suppliers.length > 0 ? (
              <Link
                style={{ color: '#e8578d' }}
                to={`${campaign_id}/suppliers`}
                state={{
                  suppliers: contact_name_filled_suppliers,
                  campaign_id,
                  name,
                  type: 'Contact Name Total Filled',
                  is_multiple_contact_name: true,
                }}
              >
                {' '}
                {contact_name_filled_total}
              </Link>
            ) : (
              contact_name_filled_total
            )}
          </Col>
          <Col >
            {contact_name_not_filled_suppliers.length > 0 ? (
              <Link
                style={{ color: '#e8578d' }}
                to={`${campaign_id}/suppliers`}
                state={{
                  suppliers: contact_name_not_filled_suppliers,
                  campaign_id,
                  name,
                  type: 'Contact Name Not Filled',
                }}
              >
                {' '}
                {contact_name_not_filled}
                <p style={{ color: 'green' }}>
                  ({contact_name_not_filled_percentage}
                  %)
                </p>
              </Link>
            ) : (
              contact_name_not_filled
            )}
          </Col>
        </Row>)
      }
    },
    {
      dataField: 'contact_number',
      text: 'Contact Number',
      sort: false,
      width: '500px',
      headerFormatter: (column) => (<><Row className="text-center"><div className="col">
        <p>Contact Number</p>
      </div> </Row><Row > <Col>Filled(Unique)</Col><Col >Total Filled</Col><Col >Not Filled</Col></Row> </>),
      formatter: (cell, row, rowIndex, extraData) => {
        const {
          campaign_id,
          contact_number_filled,
          contact_number_filled_suppliers,
          name,
          contact_number_filled_percentage,
          contact_number_filled_total,
          contact_number_not_filled,
          contact_number_not_filled_suppliers,
          contact_number_not_filled_percentage
        } = row;
        return (<Row >
          <Col>
            {contact_number_filled_suppliers.length > 0 ? (
              <Link
                style={{ color: '#e8578d' }}
                to={`${campaign_id}/suppliers`}
                state={{
                  suppliers: contact_number_filled_suppliers,
                  campaign_id,
                  name,
                  type: 'Contact Number Filled',
                  is_contact_number: true,
                }}
              >
                {' '}
                {contact_number_filled}
                <p style={{ color: 'green' }}>
                  ({contact_number_filled_percentage}
                  %)
                </p>
              </Link>
            ) : (
              contact_number_filled
            )}
          </Col>
          <Col>
            {contact_number_filled_suppliers.length > 0 ? (
              <Link
                style={{ color: '#e8578d' }}
                to={`${campaign_id}/suppliers`}
                state={{
                  suppliers: contact_number_filled_suppliers,
                  campaign_id,
                  name,
                  type: 'Contact Number Total Filled',
                  is_multiple_contact_number: true,
                }}
              >
                {' '}
                {contact_number_filled_total}
              </Link>
            ) : (
              contact_number_filled_total
            )}
          </Col>
          <Col >
            {contact_number_not_filled_suppliers.length > 0 ? (
              <Link
                style={{ color: '#e8578d' }}
                to={`${campaign_id}/suppliers`}
                state={{
                  suppliers: contact_number_not_filled_suppliers,
                  campaign_id,
                  name,
                  type: 'Contact Number Not Filled',
                }}
              >
                {' '}
                {contact_number_not_filled}
                <p style={{ color: 'green' }}>
                  ({contact_number_not_filled_percentage}
                  %)
                </p>
              </Link>
            ) : (
              contact_number_not_filled
            )}
          </Col>
        </Row>)
      }
    },
  ];
};

export default getCampaignColumn;
